import CareerPageTabs from './CareerPageTabs'
export default CareerPageTabs
